<template>
  <div class="upload-image-component">
    <div v-if="!imageUrl || onlyIcon">
      <label class="file-select" v-if="!onlyIcon">
        <div class="add-image-quiz">
          <input style="display: none;" type="file" @change="handleFileChange($event)" />
          <span class="material-icons icon-image">add_photo_alternate</span>
          <div class="icon-addd-quiz">
            <span class="material-icons">add_circle</span>
            <span>Add quiz image</span>
          </div>
        </div>
      </label>
      <label v-else>
        <div class="only-icon">
          <input style="display: none;" type="file" @change="handleFileChange($event)" />
          <IziIcon>add_photo_alternate</IziIcon>
        </div>
      </label>
    </div>

    <div class="image-challenge" v-if="imageUrl && !onlyIcon">
      <img :src="imageUrl" alt="image challenge" @click="openGalleria" class="image-small" />
      <br />
      <IziButton
        icon="pi pi-trash"
        label="remove"
        theme="text"
        buttonType="cancel"
        @click="removeImageQuestion"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { IFileModel } from "../../model/FileModel.model";
import { Vue, Options } from "vue-class-component";
import { watchEffect } from "vue";
import LayoutService from "../../services/layout.service";
import { IGalleria } from "../../model/IGalleria.model";
import { IImage } from "../../model/IImage.model";
import { useStore } from "../../store";
import { MutationTypes } from "../../store/mutations";
@Options({
  props: ["multi", "imageUrl", "onlyIcon", "imageType"]
})
export default class UploadImage extends Vue {
  multi!: boolean;
  imageUrl!: any;
  imageType!: any;
  url = "";
  images: IImage[] = [];
  displayBasic2 = false;
  onlyIcon!: boolean;
  public store = useStore();
  handleFileChange(event: any) {
    const files = event.target.files as IFileModel[];
    if (files) {
      for (const file of files) {
        file.imageType = this.imageType as string;
        this.uploadFile(file);
        this.store.commit(MutationTypes.ADD_FILE_AWAIT_UPLOAD, file);
      }
    }
  }

  uploadFile(file: any) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.url = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  created() {
    watchEffect(() => {
      this.$emit("update:imageUrl", this.url);
    });
  }

  removeImageQuestion() {
    this.$emit("update:imageUrl", "");
  }

  openGalleria() {
    if (!this.onlyIcon) {
      const galleria: IGalleria = {
        visible: true,
        value: [
          {
            src: this.imageUrl,
            alt: "image"
          }
        ]
      };
      LayoutService.setGalleria(galleria);
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-image-component {
  .add-image-quiz {
    cursor: pointer;
    height: 76px;
    border: 1px dotted $primary-icon;
    text-align: center;
    color: $primary-icon;
    padding-top: 5px;
    .icon-image {
      font-size: 40px;
    }
    .icon-addd-quiz {
      justify-content: center;
      display: flex;
    }
  }
  .only-icon {
    color: #beb9b0;
    margin-top: 10px;
    align-self: center;
    margin-left: 2px;
  }
  .image-challenge {
    text-align: center;
    .image-small {
      width: 50%;
      max-height: 120px;
    }
  }
}

@media only screen and (max-width: 425px) {
  .upload-image-component {
    .add-image-quiz {
      font-size: 12px;
    }
  }
}
</style>
